import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'ce_crm_token';

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api/crm`,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (!window.location.pathname.startsWith('/crm/login')) {
        window.location.href = '/crm/login';
      }
    }
    return Promise.reject(err);
  }
);

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function formatError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || 'Something went wrong.';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return String(d);
}

export const STAGE_META = {
  new_lead:            { label: 'New Lead',           color: '#38bdf8', light: '#e0f2fe' },
  contacted:           { label: 'Contacted',          color: '#3b82f6', light: '#dbeafe' },
  nurture:             { label: 'Nurture · Maybe Later', color: '#0891b2', light: '#cffafe' },
  proposal_sent:       { label: 'Proposal Sent',      color: '#6366f1', light: '#e0e7ff' },
  drawings_requested:  { label: 'Drawings Requested', color: '#8b5cf6', light: '#ede9fe' },
  drawings_received:   { label: 'Drawings Received',  color: '#a855f7', light: '#f3e8ff' },
  estimator_assigned:  { label: 'Estimator Assigned', color: '#d946ef', light: '#fae8ff' },
  quote_sent:          { label: 'Quote Sent',         color: '#ec4899', light: '#fce7f3' },
  approved_deposit:    { label: 'Approved · 50% Deposit', color: '#f59e0b', light: '#fef3c7' },
  in_progress:         { label: 'In Progress',        color: '#f97316', light: '#ffedd5' },
  delivered:           { label: 'Delivered',          color: '#84cc16', light: '#ecfccb' },
  final_paid:          { label: 'Final 50% Paid',     color: '#10b981', light: '#d1fae5' },
  closed_won:          { label: 'Closed Won',         color: '#059669', light: '#a7f3d0' },
  revisions:           { label: 'Revisions',          color: '#eab308', light: '#fef9c3' },
  lost:                { label: 'Lost',               color: '#64748b', light: '#e2e8f0' },
};

export function isAdmin(user) {
  return user && user !== false && user.role === 'admin';
}

export function fmtMoney(n) {
  const v = Number(n || 0);
  return v.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
}

export function fmtDate(d) {
  if (!d) return '';
  try {
    return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch { return ''; }
}

export function fmtDateTime(d) {
  if (!d) return '';
  try {
    return new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  } catch { return ''; }
}
